import { render, staticRenderFns } from "./BtnLoading.vue?vue&type=template&id=487d8144&scoped=true&"
import script from "./BtnLoading.vue?vue&type=script&lang=js&"
export * from "./BtnLoading.vue?vue&type=script&lang=js&"
import style0 from "./BtnLoading.vue?vue&type=style&index=0&id=487d8144&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487d8144",
  null
  
)

export default component.exports